import VueRouter from 'vue-router'
import $store from '../store'
import { AccessCode,checkAccess } from '@custouch/proxy-use'
import { Dialog } from 'vant'
const { DATA } = window.env
const router = new VueRouter({
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('@/views/Home'),
            meta: {
                title: '首页',
                hideContactButton: true
            }
        },
        {
            path: '/error',
            name: 'errorPage',
            component: () => import('@/views/ErrorPage')
        },
        {
            path: '/redirect',
            name: 'redirect',
            component: () => import('@/views/Redirect')
        },
        {
            path: '/productTech',
            name: 'productTech',
            component: () => import('@/views/ProductTech'),
            meta: {
                title: '产品技术',
                mId: DATA.module.productTech.id
            }
        },
        {
            path: '/search',
            name: 'search',
            component: () => import('@/views/Search'),
            meta: {
                title: '搜索'
            }
        },
        {
            path: '/interaction',
            name: 'interaction',
            component: () => import('@/views/interaction'),
            meta: {
                title: '互动专区',
                mId: DATA.module.interaction.id
            }
        },
        {
            path: '/interaction/news',
            name: 'news',
            props: r => ({ title: r.meta.title }),
            component: () => import('@/views/interaction/News'),
            meta: {
                title: '市场动态',
                hId: DATA.module.interaction.hierarchies.news,
                noTrack: true
            }
        },
        {
            // path: '/interaction/news/:name',
            path: '/interaction/news/:rId',
            name: 'newsFrame',
            props: r => ({ ...r.params,...r.query }),
            component: () => import('@/views/interaction/NewsFrame'),
            meta: {
                title: '市场动态',
                noTrack: true
            }
        },
        {
            path: '/contactUs',
            name: 'contactUs',
            component: () => import('@/views/interaction/ContactUs'),
            // props: r => ({ title: r.meta.title }),
            meta: {
                title: '联系我们',
                noTrack: true,
                hId: DATA.module.interaction.hierarchies.contactUs
            }
        },
        {
            path: '/industryApplication',
            name: 'industryApplication',
            // props: r => ({ title: r.meta.title }),
            component: () => import('@/views/IndustryApplication'),
            meta: {
                title: '行业应用',
                hId: DATA.module.productTech.hierarchies.Application,
                noTrack: true
            }
        },
        {
            // path: '/industryApplication/:level1',
            path: '/industryApplication/:hId',
            name: 'industryList',
            props: true,
            component: () => import('@/views/IndustryList'),
            meta: {
                title: '行业应用',
                noTrack: true
            }
        },
        {
            // path: '/levelPage/:section',
            path: '/levelPage/:hId',
            name: 'levelPage',
            props: true,
            component: () => import('@/views/LevelPage'),
            meta: {
                title: '列表',
                noTrack: true
            }
        },
        {
            // path: '/levelPage/:index/:section/:label/:name/',
            path: '/levelPageWithLabel/:name/:rId',
            name: 'levelPageWithLabel',
            props: true,
            component: () => import('@/views/levelPageWithLabel'),
            meta: {
                title: '列表',
                noTrack: true
            }
        },
        {
            // path: '/productDetail/:section/:name',
            path: '/productDetail/:rId',
            name: 'productDetail',
            props: r=> ({...r.params,...r.query}),
            component: () => import('@/views/ProductDetail'),
            meta: {
                title: '产品详情',
                noTrack: true
            }
        },
        {
            // path: '/documentList/:name/:type/:ids',
            path: '/documentList/:type/:rId',
            name: 'documentList',
            props: r => ({...r.params,...r.query}),
            component: () => import('@/views/DocumentList'),
            meta: {
                title: '资料列表',
                noTrack: true
            }
        },
        {
            // path: '/documentCatalog/:type',
            path: '/documentCatalog',
            name: 'documentCatalog',
            component: () => import('@/views/DocumentCatalog'),
            meta: {
                title: '精选资料',
                noTrack: true
            }
        },
        {
            // path: '/pdfViewer/:id',
            path: '/pdfViewer/:rId',
            name: 'pdfViewer',
            props: r => ({...r.params,...r.query}),
            component: () => import('@/views/PdfViewer'),
            meta: {
                title: 'pdf预览',
                noTrack: true
            }
        },
        {
            // path: '/videoViewer/:id',
            path: '/videoViewer/:rId',
            name: 'videoViewer',
            props: r => ({...r.params,...r.query}),
            component: () => import('@/views/VideoViewer'),
            meta: {
                title: '视频播放',
                noTrack: true
            }
        },
        {
            path: '/customerService',
            name: 'customerService',
            component: () => import('@/views/ticket/CustomerService'),
            meta: {
                title: '联系我们',
                hideContactButton: true
            }
        },
        {
            path: '/serviceDetail/:id',
            props: true,
            name: 'serviceDetail',
            component: () => import('@/views/ticket/ServiceDetail'),
            meta: {
                title: '客服聊天',
                hideContactButton: true
            }
        },
        {
            path: '/myFollow',
            name: 'myFollow',
            component: () => import('@/views/MyFollow'),
            meta: {
                title: '个人中心'
            }
        },
        {
            path: '/myFollow/points',
            name: 'myPoints',
            component: () => import('@/views/member/myPoints'),
            meta: {
                title: '我的积分',
                requireAuth: true
            }
        },
        {
            path: '/myFollow/exchangeRecord',
            name: 'exchangeRecord',
            component: () => import('@/views/member/exchangeRecord'),
            meta: {
                title: '兑换历史',
                requireAuth: true
            }
        },
        {
            path: '/myFollow/store',
            name: 'store',
            component: () => import('@/views/member/store'),
            meta: {
                title: '商城',
                requireAuth: true
            }
        },
        {
            path: '/myFollow/order/:id',
            name: 'order',
            component: () => import('@/views/member/order'),
            meta: {
                title: '提交订单',
                requireAuth: true
            }
        },
        {
            path: '/myFollow/address/new',
            name: 'newAddress',
            component: () => import('@/views/member/newAddress'),
            meta: {
                title: '新建收件人',
                requireAuth: true
            }
        },
        {
            path: '/myFollow/address/edit/:id',
            name: 'editAddress',
            component: () => import('@/views/member/newAddress'),
            meta: {
                title: '编辑收件人',
                requireAuth: true
            }
        },
        {
            path: '/myFollow/address',
            name: 'addressList',
            component: () => import('@/views/member/addressList'),
            meta: {
                title: '收货地址管理',
                requireAuth: true
            }
        },
        {
            path: '/myFollow/updateInfo',
            name: 'updateInfo',
            component: () => import('@/views/member/updateInfo'),
            meta: {
                title: '更新个人信息',
                requireAuth: true
            }
        },
        {
            path: '*',
            redirect: {
                name: 'home'
            }
        }
    ]
})
// 需要验证权限的话开启
if (window.env.VUE_APP_CHECK_ACCESS) {
    router.beforeEach(async (to, from, next) => {
        // const isValid = await $store.dispatch('checkAccess')
        const isValid = await validateAccess(to.meta.accessId)
        if (isValid || to.name === 'errorPage') {
            next()
        } else {
            next({ name: 'errorPage', query: { type: 0 } })
        }
    })
}
async function validateAccess(accessId, showAlert = true) {
	const { success, code, redirect } = await checkAccess(accessId,undefined,{ autoReturn: true })
	if (redirect) {
        window.location.replace(redirect)
        return false
    }
	if(!success){
		if(showAlert){
			const t = {
				title: '权限不足',
				message: '暂时无法访问该页面'
			}
			if(code === AccessCode.Accepted){
				Object.assign(t,{
					title: '信息审核中',message: '请耐心等待'
				})
			}
			return await Dialog.alert(t).then(() => validateAccess(accessId, false))
		}
		return false
	}
	return true
}
export default router
